import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { TranslationLookupService } from './translation-lookup.service.js';
import { AdminAuthInterceptor } from './common/admin-auth.interceptor.js';
import { provideTranslation } from '@neutrino/core/translation';
import { provideRouter, withPreloading } from '@angular/router';
import { routes } from './app-routes.js';
import { ClientStatePreloadingStrategy } from './client-state-preloading-strategy.js';
import { ClientStateService } from './common/client-state.service.js';
import { LeaderboardClientConfigService } from './common/leaderboard-client-config.service.js';
import { NavSectionService } from './nav-section.service.js';
import { StateStreamService } from './common/state-stream.service.js';

export const appConfig: ApplicationConfig = {
    providers: [
        provideTranslation(TranslationLookupService),
        provideAnimations(),
        importProvidersFrom(HttpClientModule),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AdminAuthInterceptor,
            multi: true
        },
        provideRouter(routes, withPreloading(ClientStatePreloadingStrategy)),
        ClientStatePreloadingStrategy,
        ClientStateService,
        LeaderboardClientConfigService,
        NavSectionService,
        StateStreamService
    ]
};
